import {ClientZoekMethode} from '../client/clientnummer-selector/clientnummer';
import UitgevoerdeTaak, {UitgevoerdeTaakDto} from './uitgevoerde-taak';

export class Prestatie {

  static deserialize(dto: PrestatieDto): Prestatie {
    return new Prestatie(
      dto.id,
      dto.clientId,
      dto.thuisverzorgerId,
      dto.thuisverzorgerNummer,
      dto.uitgevoerdeTaken.map(taakDto => UitgevoerdeTaak.deserialize(taakDto)),
      new Date(dto.startTijdstip),
      dto.startMethode,
      dto.stopTijdstip ? new Date(dto.stopTijdstip) : undefined,
      dto.stopMethode
    );
  }

  constructor(private id: string,
              private clientId: string,
              private thuisverzorgerId: string,
              private thuisverzorgerNummer: string,
              private uitgevoerdeTaken: UitgevoerdeTaak[],
              private startTijdstip: Date,
              private startMethode: ClientZoekMethode,
              private stopTijdstip?: Date,
              private stopMethode?: ClientZoekMethode,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getClientId(): string {
    return this.clientId;
  }

  getThuisverzorgerId(): string {
    return this.thuisverzorgerId;
  }

  getThuisverzorgerNummer(): string {
    return this.thuisverzorgerNummer;
  }

  getUitgevoerdeTaken(): Array<UitgevoerdeTaak> {
    return this.uitgevoerdeTaken;
  }

  getUitgevoerdeTaak(dienstId: string, categorieId: string, taakId: string): UitgevoerdeTaak | undefined {
    return this.uitgevoerdeTaken.find(taak => taak.hasTaakId(dienstId, categorieId, taakId));
  }

  isUitgevoerd(dienstId: string, categorieId: string, taakId: string): boolean {
    return !!this.getUitgevoerdeTaak(dienstId, categorieId, taakId);
  }

  getStartTijdstip(): Date {
    return this.startTijdstip;
  }

  getStartMethode(): ClientZoekMethode {
    return this.startMethode;
  }

  getStopTijdstip(): Date {
    return this.stopTijdstip;
  }

  getStopMethode(): ClientZoekMethode {
    return this.stopMethode;
  }

  hasDienst(id: string): boolean {
    return this.uitgevoerdeTaken.some(taak => taak.hasDienstId(id));
  }

  hasCategorie(dienstId: string, categorieId: string): boolean {
    return this.uitgevoerdeTaken.some(taak => taak.hasCategorieId(dienstId, categorieId));
  }

  hasTaak(dienstId: string, categorieId: string, taakId: string): boolean {
    return this.uitgevoerdeTaken.some(taak => taak.hasTaakId(dienstId, categorieId, taakId));
  }
}

export interface PrestatieDto {
  id: string;
  clientId: string;
  thuisverzorgerId: string;
  thuisverzorgerNummer: string;
  uitgevoerdeTaken: Array<UitgevoerdeTaakDto>;
  startTijdstip: string;
  startMethode: ClientZoekMethode;
  stopTijdstip?: string;
  stopMethode?: ClientZoekMethode;
}
